import { render, staticRenderFns } from "./benefits-color-picker.vue?vue&type=template&id=17931f86"
import script from "./benefits-color-picker.vue?vue&type=script&lang=js"
export * from "./benefits-color-picker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports